import ViewBase from "../../../../framework/core/mvvm/view_base";
import GameUtil from "../../../../utility/game_util";

const {ccclass, property} = cc._decorator;

@ccclass
export class QuickBuyView extends ViewBase {
    @property(cc.Label)
    mainGold:cc.Label = null;

    @property(cc.Label)
    secondGold:cc.Label = null;

    @property(cc.Label)
    disCountLab:cc.Label = null;

    @property(cc.Label)
    price:cc.Label = null;

    updateUI(data:any){
        let goodsv = data.goodsVo;
        this.price.string = parseInt(goodsv.defaultPrice,0).toString();
        this.mainGold.string = 'X'+ GameUtil.currencyFormatting(goodsv.num,2,true)

        let giftNumb = 0
        for (let i = 0; i < goodsv.giftList.length; i++) {
            let item = goodsv.giftList[i];
            giftNumb += item.num;
        }
        this.secondGold.string = 'X'+ GameUtil.currencyFormatting(giftNumb,2,true);
        let disCount = 0
        if (goodsv.num == 0) {
            disCount = 0
        }else{
            disCount = (giftNumb / goodsv.num) * 100;
            disCount = parseInt(disCount.toString(),0); 
        }
        this.disCountLab.string = 'ฟรี' + disCount + '%';
    }
}
